import React from 'react'
import { makeStyles } from '@material-ui/core'
import { HMapPanels } from '../../const/HMapPanels'
import HMapCheckbox from '../../components/HMapCheckbox'
import { useHMapContext } from '../../hooks/useHMapContext'
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight'
import GeneralButton from '../../../../components/1elements/Buttons/TextButtons/GeneralButton'

const { HMapDisplay } = HMapPanels

const HMapInstructionPanel = ({ setCurrentPanel }) => {
  const classes = useStyles()
  const { dontShowInstructionConfig } = useHMapContext()
  const [, handleDontShowInstruction] = dontShowInstructionConfig

  const handleCheckboxClick = (checked, props) => handleDontShowInstruction(checked)

  return (
    <div className={classes.root}>
      <div className={classes.left}>
        <HMapCheckbox
          className={classes.dontShowCheckbox}
          label="Don't show again"
          onClick={handleCheckboxClick}
        />
      </div>
      <div className={classes.right}>
        <GeneralButton
          config={{
            className: classes.startButton,
            onClick: () => setCurrentPanel(HMapDisplay),
            secondaryButton: false
          }}
        >
          Start <KeyboardArrowRightIcon />
        </GeneralButton>
      </div>
    </div>
  )
}

export default React.memo(HMapInstructionPanel)

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    padding: '0 0 15px 0',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  dontShowCheckbox: {
    color: theme.palette.primary.main
  },
  startButton: {
    color: 'white',
    backgroundColor: theme.palette.tertiary.accent,
    border: `2px solid ${theme.palette.tertiary.accent}`
  }
}))
